export enum LabelConfigurationWarningMode {
  NEW = 2,
  NEED_UPDATE = 1,
}
